import { BP_BOOKING_KEY, BP_FIRST_DATA_PAYMENT_FORM_KEY } from "../../../constants/balance-payments";
import SessionDataManager from "../../../util/storage-manager";

export default class BalancePaymentConfirmation {
  constructor(context) {
    this.context = context;

    this.init();
  }

  init() {
    const loginPage = this.context.dataset.balancePaymentLoginPage;
    const bookingInfo = SessionDataManager.getStorageItem(BP_BOOKING_KEY);
    if (!bookingInfo) {
      window.location.href = loginPage;
    }

    this.bookingDetails = JSON.parse(bookingInfo);

    this.textContent = this.context.querySelector('[data-element="text-content"]');
    const firstDataFormData = SessionDataManager.getStorageItem(BP_FIRST_DATA_PAYMENT_FORM_KEY);
    if (!firstDataFormData) return;
    this.firstDataPaymentForm = JSON.parse(firstDataFormData);
    if (this.firstDataPaymentForm) {
      this.setPriceText();
    }
  }

  setPriceText = () => {
    const chargeTotal = this.firstDataPaymentForm.ChargeTotal;
    const currency = Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: this.bookingDetails.CurrencyCode,
    });
    const amount = currency.format(chargeTotal);

    const childNodesArray = Array.from(this.textContent.childNodes);
    const amountHTMLElement = childNodesArray.find(childNode => childNode.textContent.includes("{amount}"));
    if (amountHTMLElement) {
      const textContent = amountHTMLElement.innerHTML.replace('{amount}', `<strong>${amount}</strong>`);
      amountHTMLElement.innerHTML = textContent;
    }
  }
}